import { OTHER_STORE_LIST, getOtherStoreDefinition } from "../visoria/stores";

/** Серверная страница (Visoria через Apache): только обычной ссылкой, не через React Router. */
export const NINTENDO_GAMES_PATH = "/nintendo/igry";
export const OTHER_STORES_ANCHOR = "/#other-stores";

/** Шапка: Nintendo и PlayStation — прямые ссылки, у Steam и «Скидок» подменю. */
export const NINTENDO_SHOP_PATH = "/nintendo-eshop/shop";
export const PLAYSTATION_SHOP_PATH = "/playstation/shop";
export const STEAM_MENU_LINKS = [
  { to: "/steam", label: "Пополнение" },
  { to: "/steam/shop", label: "Коды" },
];
export const DISCOUNT_MENU_LINKS = [
  { to: "/nintendo-discount", label: "Nintendo" },
  { to: "/steam-discount", label: "Steam" },
  { to: "/playstation-discount", label: "PlayStation" },
];

export const SECTION_LINKS = [
  {
    id: "nintendo-shop",
    to: "/nintendo-eshop/shop",
    label: "Карты Nintendo eShop",
    hint: "США и Польша",
    keywords: ["nintendo", "нинтендо", "eshop", "ешоп", "switch", "свитч", "карта"],
  },
  {
    id: "nintendo-discount",
    to: "/nintendo-discount",
    label: "Скидки Nintendo",
    hint: "распродажи eShop в рублях",
    keywords: ["скидки", "распродажа", "sale", "nintendo", "нинтендо"],
  },
  {
    id: "nintendo-games",
    href: NINTENDO_GAMES_PATH,
    label: "Игры Nintendo Switch",
    hint: "все игры с ценами в рублях",
    keywords: ["игры", "каталог", "nintendo", "нинтендо", "switch", "свитч"],
  },
  {
    id: "steam-topup",
    to: "/steam",
    label: "Пополнение Steam",
    hint: "по логину, Россия и СНГ",
    keywords: ["steam", "стим", "пополнить", "пополнение", "кошелек"],
  },
  {
    id: "steam-shop",
    to: "/steam/shop",
    label: "Коды Steam",
    hint: "подарочные карты Steam",
    keywords: ["steam", "стим", "коды", "код", "карта", "подарок"],
  },
  {
    id: "steam-discount",
    to: "/steam-discount",
    label: "Скидки Steam",
    hint: "распродажи и цены в рублях",
    keywords: ["скидки", "распродажа", "sale", "steam", "стим"],
  },
  {
    id: "playstation-shop",
    to: "/playstation/shop",
    label: "Карты PlayStation Store",
    hint: "Польша и Индия",
    keywords: ["playstation", "плейстейшн", "плойка", "psn", "ps5", "ps4", "карта"],
  },
  {
    id: "playstation-discount",
    to: "/playstation-discount",
    label: "Скидки PlayStation",
    hint: "распродажи PS Store в рублях",
    keywords: ["скидки", "распродажа", "sale", "playstation", "плейстейшн", "psn"],
  },
  {
    id: "account",
    to: "/account",
    label: "Мои заказы и коды",
    hint: "личный кабинет",
    keywords: ["кабинет", "заказ", "заказы", "код", "коды", "войти", "где мой код"],
  },
];

const STORE_KEYWORDS = {
  nintendo: ["nintendo", "нинтендо", "eshop", "ешоп"],
  "nintendo-membership": ["switch online", "nintendo online", "nso", "подписка nintendo"],
  steam: ["steam", "стим", "wallet"],
  playstation: ["playstation", "плейстейшн", "плойка", "psn", "ps5", "ps4"],
  xbox: ["xbox", "иксбокс", "хбокс", "microsoft"],
  "xbox-game-pass": ["game pass", "gamepass", "гейм пасс", "геймпасс"],
  apple: ["apple", "эпл", "эппл", "app store", "itunes", "айтюнс", "iphone", "айфон"],
  spotify: ["spotify", "спотифай", "музыка"],
  fortnite: ["fortnite", "фортнайт", "v-bucks", "vbucks", "вбакс", "в-баксы"],
  roblox: ["roblox", "роблокс", "robux", "робукс"],
  riot: ["riot", "райот", "valorant", "валорант", "league of legends", "lol", "лол"],
  pubg: ["pubg", "пабг", "пубг", "uc", "юси"],
};

export const STORE_LINKS = OTHER_STORE_LIST.map((store) => {
  const definition = getOtherStoreDefinition(store.id);
  return {
    id: `store-${store.id}`,
    storeId: store.id,
    to: `/store/${store.id}`,
    label: definition.pageTitle,
    shortLabel: store.label,
    hint: definition.genre,
    keywords: STORE_KEYWORDS[store.id] || [],
  };
});

export function normalizeQuery(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/\s+/g, " ")
    .trim();
}

function linkMatches(link, query) {
  const haystack = [link.label, link.hint, ...link.keywords].map(normalizeQuery);
  return haystack.some((text) => text.includes(query) || (text.length >= 3 && query.includes(text)));
}

/** Разделы и магазины, подходящие под запрос: сначала основные разделы, потом «другие магазины». */
export function matchSiteLinks(rawQuery, limit = 6) {
  const query = normalizeQuery(rawQuery);
  if (query.length < 2) {
    return [];
  }
  return [...SECTION_LINKS, ...STORE_LINKS].filter((link) => linkMatches(link, query)).slice(0, limit);
}
